<template>
	<div class="app_body" ref="app_body">
		<div class="tab_wrapper1">
			<div class="flex">
				<div class="tabs">
					<div class="tab" :class="{'selected': current_tab_index === 0}" @click="current_tab_index = 0"><p>
						住所から探す</p></div>
					<div class="tab" :class="{'selected': current_tab_index === 1}" @click="current_tab_index = 1"><p>
						キーワードから探す</p></div>
					<div class="bar pc" :style="{left: `calc(280px * ${current_tab_index})`}"></div>
					<div class="bar sp" :style="{left: `calc(100% / 2 * ${current_tab_index})`}"></div>
				</div>
			</div>

			<div class="search" v-show="current_tab_index === 0">
				<p>都道府県を選んで「検索」ボタンを押してください。</p>
				<div class="shop_dropdown">
					<div class="select_body">
						<select class="slt_green" v-model="select_p">
							<option disabled value="">選択して下さい</option>
							<option>全て</option>
							<optgroup label="北海道／東北">
								<option>北海道</option>
								<option>青森県</option>
								<option>岩手県</option>
								<option>宮城県</option>
								<option>秋田県</option>
								<option>山形県</option>
								<option>福島県</option>
							</optgroup>
							<optgroup label="関東">
								<option>茨城県</option>
								<option>栃木県</option>
								<option>群馬県</option>
								<option>埼玉県</option>
								<option>千葉県</option>
								<option>東京都</option>
								<option>神奈川県</option>
							</optgroup>
							<optgroup label="甲信越／北陸">
								<option>新潟県</option>
								<option>富山県</option>
								<option>石川県</option>
								<option>福井県</option>
								<option>山梨県</option>
								<option>長野県</option>
							</optgroup>
							<optgroup label="東海">
								<option>岐阜県</option>
								<option>静岡県</option>
								<option>愛知県</option>
								<option>三重県</option>
							</optgroup>
							<optgroup label="近畿">
								<option>滋賀県</option>
								<option>京都府</option>
								<option>大阪府</option>
								<option>兵庫県</option>
								<option>奈良県</option>
								<option>和歌山県</option>
							</optgroup>
							<optgroup label="中国">
								<option>鳥取県</option>
								<option>島根県</option>
								<option>岡山県</option>
								<option>広島県</option>
								<option>山口県</option>
							</optgroup>
							<optgroup label="四国">
								<option>徳島県</option>
								<option>香川県</option>
								<option>愛媛県</option>
								<option>高知県</option>
							</optgroup>
							<optgroup label="九州／沖縄">
								<option>福岡県</option>
								<option>佐賀県</option>
								<option>長崎県</option>
								<option>熊本県</option>
								<option>大分県</option>
								<option>宮崎県</option>
								<option>鹿児島県</option>
								<option>沖縄県</option>
							</optgroup>
						</select>
					</div>
					<div class="select_body">
						<select class="slt_green" v-model="select_m">
							<option disabled value="">選択して下さい</option>
							<option v-for="(item, i) in list_m" :key="i">{{ item }}</option>
						</select>
					</div>

					<div class="buttons action" @click="gmapSearch()">検索</div>
				</div>
			</div>

			<div class="search" v-show="current_tab_index === 1">
				<div class="shop_keyword">
					<div class="cp_iptxt"><input v-model="keyword" placeholder="駅名・住所などキーワードから探す"></div>
					<div class="buttons action" @click="gmapKeyword()">検索</div>
					<p v-show="error_flag === true" class="keyword_error">販売店が見つかりませんでした。</p>
				</div>
			</div>

		</div>
		<div class="tab_wrapper2">
			<div class="flex">
				<div class="tabs">
					<div class="tab selected"><p>地図から探す</p></div>
					<div class="bar"></div>
				</div>
			</div>
			<div class="search">
				<p>検索したいエリアにズーム（地図の「+」ボタンをクリック）してから、地図左上にある検索ボタンをクリックするとショップが表示されます。</p>
				<GoogleMapLoader ref="ref_gmap"/>
			</div>
		</div>
		<div class="result">
			<ul>
				<router-link :to="{ name: 'Shop', params: { id: shop['ID'] }}" v-for="(shop, i) in shopList" :key="i">
					<li>
						<div class="marker"><img
							src="data:image/png;base64,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"
							alt=""></div>
						<div class="info">
							<div class="shop_name">{{ shop['販売店名'] }}</div>
							<div class="zip_code">〒{{ shop['郵便番号'] }}</div>
							<div class="address">{{ shop['住所'] }}</div>
							<div class="tel">TEL {{ shop['TEL'] }}</div>
						</div>
					</li>
				</router-link>
			</ul>
		</div>
	</div>
</template>

<script>
import GoogleMapLoader from '@/components/GoogleMapLoader'


export default {
	name: "Search",
	components: {GoogleMapLoader},
	data() {
		return {
			current_tab_index: 0,
			keyword: '',
			error_flag: false
		}
	},

	computed: {
		select_p: {
			get() {
				return this.$store.state.selected_prefectures
			},
			set(value) {
				this.$store.commit('SET_MUNI', '');
				this.$store.commit('SET_PREF', value);
			}
		},
		select_m: {
			get() {
				return this.$store.state.selected_municipality
			},
			set(value) {
				this.$store.commit('SET_MUNI', value);
			}
		},
		list_m() {
			let list = this.$store.state.municipality_data;
			return list[this.$store.state.selected_prefectures];
		},
		shopList() {
			return this.$store.state.result_shopList;
		}
	},

	methods: {
		gmapSearch() {
			this.$refs.ref_gmap.setDisplay_premun();
			this.scrollToAnchorPoint('app_body');
		},
		gmapKeyword() {
			this.error_flag = false;

			//入力されたキーワードから全角スペースを半角に
			let keyword = this.keyword.replace(/[\x20\u3000]/g, " ");
			let keyword_array = keyword.split(' ');

			//全店舗データと検索項目マスタを準備
			let shop_dt = this.$store.state.excel_data;
			let item_mt = this.$store.state.excel_item_master;
			//スペースで区切られたキーワードで絞り込み検索
			for (let k = 0; k < keyword_array.length; k++) {
				let temp_array = [];
				for (let i = 0; i < shop_dt.length; i++) {
					for (let n = 0; n < item_mt.length; n++) {
						if(String(shop_dt[i][item_mt[n]]).indexOf(keyword_array[k]) !== -1) {
							temp_array[i] = shop_dt[i];
						}
					}
				}
				//ひとつもひっかからないならここで終わり
				if(temp_array.length === 0) {
					this.error_flag = true;
					return;
				}

				shop_dt = temp_array;
				//リストを整列しなおして
				let count = 0;
				let return_array = [];
				for (let j in temp_array) {
					return_array[count] = temp_array[j];
					count++;
				}
				shop_dt = return_array;
			}

			this.$refs.ref_gmap.setDisplay_Keyword_markers(shop_dt);
			this.scrollToAnchorPoint('app_body');
		},
		//アンカーリンク動作
		scrollToAnchorPoint(refName) {
			const el = this.$refs[refName]
			el.scrollIntoView({behavior: 'smooth'})
		}
	}
}

</script>

<style scoped>

.app_body {
	width: 100%;
	max-width: 1200px;
	margin: 0 auto 20px;
	padding: 0 25px 0 10px;
}

.tab_wrapper1, .tab_wrapper2 {
	margin-bottom: 30px;
}


.flex {
	display: flex;
	justify-content: space-between;
	align-items: flex-end;

	border-bottom: solid 1px var(--toso_base_black);
}

.tabs {
	position: relative;
	display: flex;
	justify-content: left;
}

.tab_wrapper1 .tab {
	cursor: pointer;
}

.tabs .tab {
	width: 280px;
	text-align: center;
	display: flex;
	justify-content: center;
	margin-bottom: 4px;
	font-size: 1.6rem;
}

.tab_wrapper1 .tabs .tab:hover {
	opacity: 0.8;
	color: var(--toso_base_green);
}

.tabs .tab.selected {
	font-weight: bold;
	color: var(--toso_base_green);
}

.tabs .tab p {
	margin-bottom: 5px;
}

.tabs .bar {
	position: absolute;
	bottom: 0;
	left: 0;
	width: 280px;
	height: 4px;
	background-color: var(--toso_base_green);
	transition: 0.5s;
}

.tabs .bar2 {
	position: absolute;
	bottom: 0;
	width: 280px;
	height: 4px;
	background-color: var(--toso_base_green);
	transition: 0.5s;
}

.search p {
	margin: 10px 0
}

.shop_keyword {
	display: flex;
	margin: 20px 0;
}

.shop_keyword div {
	margin: 0 10px 0 0;
}

.shop_keyword .cp_iptxt {
	position: relative;
}

.shop_keyword .cp_iptxt:before {
	content: "";
	position: absolute;
	height: 32px;
	right: 5px;
	top: 0;
	bottom: 0;
	width: 30px;
	background: url("/shop/images/search_icon.svg") center / contain no-repeat;
}

.shop_keyword .cp_iptxt input {
	width: 280px;
	height: 32px;
	box-sizing: border-box;
	padding: 0.3em;
	transition: 0.3s;
	border: 1px solid #7D7D7D;
	outline: none;
}

.shop_keyword .cp_iptxt input:focus {
	border-color: var(--toso_base_green);
}

.shop_keyword .cp_iptxt input {
	padding-left: 5px;
}

.shop_keyword .cp_iptxt i {
	position: absolute;
	top: 8px;
	left: 0;
	padding: 9px 8px;
	transition: 0.3s;
	color: #aaaaaa;
}

.shop_keyword .cp_iptxt input:focus + i {
	color: var(--toso_base_green);
}


.select_body {
	overflow: hidden;
	width: 280px;
	height: 32px;
	text-align: center;
	position: relative;
	background-color: #F4F4F4;
}

.select_body select {
	width: 100%;
	height: 32px;
	cursor: pointer;
	border: none;
	outline: none;
	background: transparent none;
	box-shadow: none;
	-webkit-appearance: none;
	appearance: none;
	transition: .3s;
}

.select_body select::-ms-expand {
	display: none;
}

.select_body::before {
	position: absolute;
	top: 13px;
	right: 13px;
	width: 0;
	height: 0;
	padding: 0;
	content: '';
	border-left: 6px solid transparent;
	border-right: 6px solid transparent;
	border-top: 6px solid #000000;
	pointer-events: none;
}

.select_body:hover::after {
	position: absolute;
	top: 13px;
	right: 13px;
	width: 0;
	height: 0;
	padding: 0;
	content: '';
	border-left: 6px solid transparent;
	border-right: 6px solid transparent;
	border-top: 6px solid white;
	pointer-events: none;
}

.select_body select {
	color: #000000;
}

.select_body select:hover {
	color: white !important;
	background-color: var(--toso_base_green);
}

select option,
select optgroup {
	color: #000000;
	background-color: white;
}

.buttons.action {
	width: 130px;
	height: 32px;
}

.buttons button {
	font-weight: bold;
}

.buttons:hover {
	color: white;
}


.shop_dropdown {
	display: flex;
}

.shop_dropdown div {
	margin: 0 10px 0 0;
}

.shop_dropdown option {
	text-indent: 1rem;
}


.result ul li {
	display: flex;
	height: 60px;
	border-bottom: 1px solid var(--toso_base_gray);
	align-items: center;
	cursor: pointer;
}

.result ul li:hover {
	background-color: var(--toso_base_gray);
}


.result ul li .info {
	display: flex;
	width: 100%;
	line-height: 1.6;
}

.result ul li .marker {
	margin: 5px 15px 5px 5px;
	width: 26px;
}

/*.result ul li .info div{border:1px solid red;}*/
.result ul li .info .shop_name {
	width: 20%
}

.result ul li .info .zip_code {
	width: 10%
}

.result ul li .info .address {
	width: 30%
}

.result ul li .info .tel {
	width: auto
}

.keyword_error {
	color: red;
}

@media screen and (max-width: 750px) {

	.app_body {
		margin: 20px auto 20px;
		padding: 0 10px 0 10px;
		font-size: 1.5rem;
	}

	.tabs .tab {
		font-size: 1.5rem;
	}

	.tab_wrapper2 .tabs .tab {
		width: 50%;
	}

	.tabs .bar {
		width: 50%;
	}

	.tab_wrapper2 .tabs {
		width: 100%;
	}

	.shop_dropdown {
		flex-flow: column;
	}

	.shop_dropdown div {
		margin-bottom: 10px;
		margin-right: 0;
		margin-left: auto;
	}

	.select_body {
		width: 100%;
	}

	.result ul li {
		align-items: flex-start;
		height: auto;
		padding: 10px 0;
	}

	.result ul li .info {
		display: flex;
		flex-flow: column;
	}

	.result ul li .info .shop_name {
		width: initial
	}

	.result ul li .info .zip_code {
		width: initial
	}

	.result ul li .info .address {
		width: initial
	}

	.result ul li .info .tel {
		width: initial
	}

	.select_body select {
		font-size: 16px;
	}
}
</style>